import { FunctionComponent } from 'react'
import {
  Box,
  Typography,
  Button,
  Link,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import DashboardLayout from '../../../components/layout/layout'

const TechnicalRequest: FunctionComponent = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <DashboardLayout 
      title="Sales Tools" 
      initialBreadcrumbs="Sales Tools" 
      levelBreadcrumbs="" 
      breadcrumbs="Sales Tools" 
      activeMenu="resources"
    >
      <Box>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Sales Tools: Technical Request
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.6 }}>
            If you have a technical support issue, whether it is troubleshooting, product selection or competitor cross reference, please
            fill out the form below for fastest service. After submitting your request, check your inbox for email confirmation.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Link
              href="https://www.barksdale.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: 'none',
                color: '#1976d2', // Blue color for hyperlinks
                fontWeight: 400,
                ...theme.typography.body1,
                textAlign: 'left',
                padding: '8px 0',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                  color: '#1565c0', // Darker blue on hover
                },
              }}
            >
              https://www.barksdale.com/contact-us
            </Link>
          </Box>
        </Box>

        {/* Back to Sales Tools button - at the bottom like main Sales Tools page */}
        <Box sx={{ textAlign: 'left', mt: 4 }}>
          <Button
            variant="contained"
            onClick={() => navigate('/resources')}
            sx={{
              bgcolor: '#c8102e',
              textTransform: 'none',
              fontWeight: 600,
              ...theme.typography.button,
              '&:hover': { bgcolor: '#a30f24' },
            }}
          >
            BACK
          </Button>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default TechnicalRequest; 